module.exports = __webpack_public_path__ + "img/2.5e64029a.jpg";